"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.quickOffer.name': 'Szybka Oferta',
    'tools.quickOffer.description': 'Zbiera pola formularza szybkiej oferty z wiadomości użytkownika na podstawie skonfigurowanych pól i opcji',
};
